// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xhT6b","option":"styles_option__20be5","active":"styles_active__3_Okv"};